<template>
  <div class="grey lighten-4">
    <div class="px-5 py-5">
      <v-row>
        <v-col cols="6" sm="6" lg="3">
          <h6 class="text-uppercase grey--text">
            {{ $t('transfer.details.status') }}
          </h6>
          <v-chip :color="handleColors(transfer.status)" v-if="transfer.status">
            {{ $t(`transfer.transferStatus.${transfer.status}`) }}
          </v-chip>
          <span class="body-2" v-else>---</span>
        </v-col>
        <v-col cols="6" sm="6" lg="3">
          <h6 class="text-uppercase grey--text">
            {{ $t('transfer.details.total') }}
          </h6>
          <span class="body-2" v-if="transfer.total">
            {{ formatMoney(transfer.total) }}
          </span>
          <span class="body-2" v-else>---</span>
        </v-col>
        <v-col cols="6" sm="6" lg="3">
          <h6 class="text-uppercase grey--text">
            {{ $t('transfer.details.createdAt') }}
          </h6>
          <span class="body-2" v-if="transfer.created_at">
            {{ formatDate(transfer.created_at) }}
          </span>
          <span class="body-2" v-else>---</span>
        </v-col>
        <v-col cols="6" sm="6" lg="3">
          <h6 class="text-uppercase grey--text">
            {{ $t('transfer.details.updatedAt') }}
          </h6>
          <span class="body-2" v-if="transfer.updated_at">
            {{ formatDate(transfer.updated_at) }}
          </span>
          <span class="body-2" v-else>---</span>
        </v-col>
      </v-row>

      <v-row>
        <v-col cols="6" sm="6" lg="3">
          <h6 class="text-uppercase grey--text">
            {{ $t('transfer.details.asaasId') }}
          </h6>
          <v-chip class="body-2" v-if="transfer.asaas_transfer_id">
            {{ transfer.asaas_transfer_id }}
            <CopyToClipboard :value="transfer.asaas_transfer_id" />
          </v-chip>
          <span class="body-2" v-else>---</span>
        </v-col>
        <v-col v-if="transferAppointment" cols="6" sm="6" lg="3">
          <h6 class="text-uppercase grey--text">
            {{ $t('transfer.details.appointment') }}
          </h6>
          <v-btn
            :href="`/admin-appointment/${transferAppointment.id}`"
            target="_blank"
            color="primary"
            small
            text
          >
            <v-icon small left>
              mdi-open-in-new
            </v-icon>
            <span class="body-2">
              {{ transferAppointment.code }}
            </span>
          </v-btn>
        </v-col>
        <v-col cols="6" sm="6" lg="3">
          <h6 class="text-uppercase grey--text">
            {{ $t('transfer.details.receiver') }}
          </h6>
          <span class="body-2">
            {{ $t(`transfer.receiverType.${transfer.receiver_type}`) }}
          </span>
        </v-col>
      </v-row>
    </div>
  </div>
</template>

<script>
import CopyToClipboard from '@/components/app/CopyToClipboard'

import { catalogDate, catalogMonetary } from '@/util/catalog'
import { handleColors } from '@/util/colors'

export default {
  name: 'TransferData',

  components: {
    CopyToClipboard,
  },

  props: {
    transfer: {
      type: Object,
      required: true,
    }
  },

  computed: {
    transferAppointment() {
      return this.transfer.appointment
    }
  },

  data() {
    return {
      formatMoney: catalogMonetary,
      formatDate: catalogDate,
      handleColors,
    }
  }
}
</script>
